/* Checkout+ add-on controller — auto-adds (opt-out) the Checkout+ product to the
   cart, keeps it in sync, handles the "Continue Without Checkout+" opt-out, and
   the benefits modal. Persists across cart re-renders via document-level events. */
(function () {
  var CP = window.PR_CP_VARIANT;
  if (!CP) return;
  var OPTOUT = 'pr_cp_optout';
  var busy = false;

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function sectionIds() {
    var c = getCart();
    try { return c && c.getSectionsToRender ? c.getSectionsToRender().map(function (s) { return s.id; }) : []; }
    catch (e) { return []; }
  }
  function rerender(res) {
    var c = getCart();
    if (c && res && res.sections && typeof c.renderContents === 'function') {
      try { c.renderContents(res); return true; } catch (e) {}
    }
    return false;
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addCP() {
    // append via /cart/add.js (end of cart) — /cart/update.js was prepending it and shifting line indices (broke qty/remove)
    return post('/cart/add.js', { items: [{ id: CP, quantity: 1 }], sections: sectionIds(), sections_url: location.pathname })
      .then(rerender);
  }
  function removeCP() {
    // full clean re-render (not a partial one) so the empty-cart transition doesn't
    // leave a malformed drawer (header shoved to the bottom).
    return post('/cart/change.js', { id: String(CP), quantity: 0 }).then(hardRefreshDrawer);
  }
  function hardRefreshDrawer(cart) {
    return fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          // Lumin drives the empty layout via .is-empty on the <cart-drawer> element,
          // which our inner-HTML swap doesn't touch — toggle it so the grid stays valid.
          var cd = document.querySelector('cart-drawer');
          if (cd) {
            var isEmpty = (cart && typeof cart.item_count === 'number')
              ? cart.item_count === 0
              : !document.querySelector('.cart-item');
            cd.classList.toggle('is-empty', isEmpty);
          }
        } catch (e) {}
      });
  }

  function ensure() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var GIFT = (window.PR_GIFT && window.PR_GIFT.variant) || 0;
        var cpPresent = false, realCount = 0;
        (cart.items || []).forEach(function (it) {
          if (it.id === CP || it.variant_id === CP) cpPresent = true;
          else if (GIFT && (it.id === GIFT || it.variant_id === GIFT)) { /* free gift add-on — not a real product */ }
          else realCount += it.quantity;
        });
        var optedOut = false;
        try { optedOut = sessionStorage.getItem(OPTOUT) === '1'; } catch (e) {}

        var action = null;
        if (optedOut) { if (cpPresent) action = removeCP; }
        else if (realCount > 0 && !cpPresent) action = addCP;
        else if (realCount === 0 && cpPresent) action = removeCP;

        if (action) { return action().then(function () { busy = false; }); }
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  /* modal */
  function modal() { return document.querySelector('[data-pr-cp-modal]'); }
  function openModal() { var m = modal(); if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; } }
  function closeModal() { var m = modal(); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; } }

  function optOutAndCheckout() {
    try { sessionStorage.setItem(OPTOUT, '1'); } catch (e) {}
    removeCP().then(function () { window.location = '/checkout'; })
              .catch(function () { window.location = '/checkout'; });
  }

  function flipToggle(on) {
    var t = document.querySelector('[data-pr-cp-toggle]');
    var row = document.querySelector('[data-pr-cp-rowwrap]');
    if (t) { t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on ? 'true' : 'false'); }
    if (row) row.classList.toggle('is-off', !on);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pr-cp-info]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-pr-cp-modal-close]')) { e.preventDefault(); closeModal(); return; }
    if (e.target.closest('[data-pr-cp-continue]')) { e.preventDefault(); optOutAndCheckout(); return; }
    var toggle = e.target.closest('[data-pr-cp-toggle]');
    if (toggle) {
      e.preventDefault();
      var turnOn = toggle.getAttribute('aria-checked') !== 'true';
      flipToggle(turnOn);   // optimistic — the re-render confirms it
      if (turnOn) {
        try { sessionStorage.removeItem(OPTOUT); } catch (err) {}
        addCP();
      } else {
        try { sessionStorage.setItem(OPTOUT, '1'); } catch (err) {}
        removeCP();
      }
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* keep in sync — Lumin's pub/sub globals are top-level `const`, so they are
     bare lexical globals (NOT window.*). Guard with typeof and retry for order. */
  var subscribed = false;
  function pubsubReady() {
    try { return typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function'; }
    catch (e) { return false; }
  }
  function trySubscribe(tries) {
    if (!subscribed && pubsubReady()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(ensure, 80); });
      subscribed = true;
      return;
    }
    if (tries > 0) setTimeout(function () { trySubscribe(tries - 1); }, 150);
  }
  trySubscribe(40);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure);
  else ensure();
})();
